module.exports = __webpack_public_path__ + "static/media/CTLI_17-391w.db51a732.webp";